export default __webpack_public_path__ + "static/summer_containers75-d0fd32e4d5784217d270b5b52e6cc077.webp";